"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const BrandBox_juomat_1 = require("./Elements/BrandBox-juomat");
const Store_1 = require("./Store");
const ContentArea_1 = require("./Elements/ContentArea");
const SubcategoryBox_1 = require("./Elements/SubcategoryBox");
const Hero_1 = require("./Elements/Hero");
const react_slick_1 = require("react-slick");
const mobx_1 = require("mobx");
let BrandList = class BrandList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disableSlider: window.innerWidth > 768
        };
    }
    componentDidMount() {
        document.title = (Store_1.default.SelectedCategory ? Store_1.default.SelectedCategory.name : Store_1.default.currentPageName) + " | Hartwall";
        //store.updateNavigationColor(store.containerId);
        window.addEventListener('resize', this.updateWidth.bind(this));
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }
    updateWidth() {
        if (this.state.disableSlider === false && window.innerWidth > 768) {
            this.setState({ disableSlider: true });
        }
    }
    onShowAllClick() {
        this.setState({ disableSlider: true });
    }
    render() {
        const hasSubcategories = Store_1.default.Subcategories !== null && Store_1.default.Subcategories.length > 0;
        const canRenderSlider = this.state.disableSlider === false && hasSubcategories === true && Store_1.default.Subcategories.length > 3;
        const subcategoriesText = Store_1.default.SelectedCategory.subcategoriesText;
        const brandsText = Store_1.default.SelectedCategory.brandsText;
        const linkText = Store_1.default.SelectedCategory.readMoreLinkText || Store_1.default.Translations.readMoreLinkText;
        const sliderSettings = {
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3.5,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 2
                    }
                }
            ]
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("article", { id: "main-content" },
                React.createElement(Hero_1.default, { backgroundImageUrl: Store_1.default.SelectedCategory.backgroundImageUrl, dimFilter: Store_1.default.SelectedCategory.dimFilter, heading: Store_1.default.SelectedCategory.categoryHeader, ingressText: Store_1.default.SelectedCategory.categoryIngress, link: Store_1.default.SelectedCategory.readMoreLink, linkText: linkText }),
                (hasSubcategories === true) && React.createElement("div", { className: "o-container u-mb-2" },
                    React.createElement("div", { className: "row u-mb-1 _sm-u-mb-2" },
                        React.createElement("div", { className: "col-xs-6" },
                            React.createElement("h2", { className: "s-h3-s u-mt-05 u-mb-0" }, subcategoriesText)),
                        React.createElement("div", { className: "col-xs-6" }, (canRenderSlider === true) && React.createElement("button", { className: "o-button blue show-all _sm-d-none", onClick: this.onShowAllClick.bind(this) }, Store_1.default.Translations.showAllText))),
                    (canRenderSlider === false) && React.createElement("div", { className: "row" }, Store_1.default.Subcategories.map(function (subcategory) {
                        return (React.createElement(SubcategoryBox_1.default, Object.assign({ key: subcategory.id }, subcategory)));
                    })),
                    (canRenderSlider === true) && React.createElement(react_slick_1.default, Object.assign({ className: "o-filter-slider" }, sliderSettings), Store_1.default.Subcategories && Store_1.default.Subcategories.map(function (subcategory) {
                        return (React.createElement(SubcategoryBox_1.default, Object.assign({ key: subcategory.id }, subcategory)));
                    }))),
                React.createElement(ContentArea_1.default, { content: Store_1.default.SelectedCategory.id, language: Store_1.default.currentLanguage, area: "TopContentArea" }),
                React.createElement("div", { className: "o-container" },
                    React.createElement("h3", { className: "s-h3-s u-mt-0 u-mb-1 _sm-u-mb-2 u-pl-1" }, brandsText)),
                React.createElement("div", { className: "o-container u-mb-4" },
                    React.createElement("div", { className: "o-product-listing-wrapper" },
                        Store_1.default.loading &&
                            React.createElement("div", { className: "ui active inverted dimmer" },
                                React.createElement("div", { className: "ui text loader" }, Store_1.default.Translations.loadingText)),
                        React.createElement("div", { className: "row" }, Store_1.default.Brands && Store_1.default.Brands.map(function (brand) {
                            return (React.createElement(BrandBox_juomat_1.default, Object.assign({ key: brand.id }, brand)));
                        }))))),
            React.createElement("section", { id: "related-articles" },
                React.createElement(ContentArea_1.default, { content: Store_1.default.SelectedCategory.id, language: Store_1.default.currentLanguage, area: "BottomContentArea", backupContent: Store_1.default.containerId, backupArea: "ProductContentArea" }))));
    }
};
__decorate([
    mobx_1.action
], BrandList.prototype, "onShowAllClick", null);
BrandList = __decorate([
    mobx_react_1.observer
], BrandList);
exports.default = BrandList;
